import { comparisonFieldLabel } from "@kollectivia/shared";
import { useTranslation } from "react-i18next";

import { normalizeLang } from "../../../lib/apiErrorMessage";
import { useProjectComparison } from "../../../lib/queries/comparison";
import { CellStatusBadge } from "../../projects/_parts/CellStatusBadge";
import { toComparisonLocale } from "../../projects/_parts/comparisonFormat";
import { ComparisonValue } from "../../projects/_parts/ComparisonValue";

export function ComparedSourceValue({
  projectId,
  submissionId,
  field,
  quoteRequestId,
}: {
  projectId: string;
  submissionId: string;
  field: string;
  quoteRequestId?: string;
}) {
  const { t, i18n } = useTranslation();
  const query = useProjectComparison({ projectId, quoteRequestId });
  const cell = query.data?.rows.find((row) => row.field_key === field)?.cells[submissionId];
  return (
    <section className="space-y-3 rounded-xl border bg-white p-4">
      <h2 className="font-semibold">
        {comparisonFieldLabel(field, normalizeLang(i18n.resolvedLanguage))}
      </h2>
      <p className="text-sm text-slate-600">{t("reception_flow.compared_value")}</p>
      {query.isLoading ? (
        <p role="status">{t("app.loading")}</p>
      ) : query.error ? (
        <p role="alert">{t("errors.generic")}</p>
      ) : cell ? (
        <>
          <ComparisonValue
            value={cell.value}
            unit={cell.unit}
            fieldKey={field}
            locale={toComparisonLocale(i18n.resolvedLanguage)}
            tooltipPrefix={t("comparison.format.tooltip_original_value")}
          />
          <div>
            <CellStatusBadge cell={cell} />
          </div>
        </>
      ) : (
        <p role="status">{t("reception_flow.value_unavailable")}</p>
      )}
    </section>
  );
}
